import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AccordionModule} from 'primeng/accordion';
import { TableModule} from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import {ConfirmationService} from 'primeng/api';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { CalendarModule} from 'primeng/calendar';
// import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { CasesComponent } from './cases/cases.component';
import { BoardMemberComponent } from './board/board-member.component';
import { HearingDateComponent } from './hearings/hearing-date.component';

import { LoginRouteGuard } from 'src/app/login-route-guard';

import { DatePipe } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    AccordionModule,
    TableModule,
    FormsModule,
    ToastModule,
    ConfirmDialogModule,
    CalendarModule,
    RouterModule.forChild([
      { path: 'schedcases', component: CasesComponent, canActivate: [LoginRouteGuard] },
      { path: 'boardmembers', component: BoardMemberComponent, canActivate: [LoginRouteGuard] },
      { path: 'hearings', component: HearingDateComponent, canActivate: [LoginRouteGuard]}
    ]),
    // ProgressSpinnerModule,
  ],
  declarations: [
    CasesComponent,
    BoardMemberComponent,
    HearingDateComponent
  ],
  providers: [
    MessageService,
    ConfirmationService,
    DatePipe
  ]
})
export class ScheduleModule { }
